import React, { Dispatch, RefObject, useEffect, useMemo, useRef, useState } from "react";
import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";
import { useDispatch, useSelector } from "react-redux";

import styles from "./chat-info.module.scss";
import { ChatInfoProps } from "./chat-info.types";

import { ApplicationStore } from "~/app/application.store";
import { makeSelectChatInfoById } from "~/app/selectors/chats";
import chatActions from "~/app/chat/chat.actions";

const ChatInfoComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const [isClickChangeName, setIsClickChangeName]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] =
    useState<boolean>(false);

  const refInputChangeName: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null);

  const chatId: string | null = useSelector((state: ApplicationStore) => state.chats.selectChatId);

  const selectChatInfoById: (state: ApplicationStore, chatId: string | null) => ChatWithShortInfo | undefined = useMemo(
    () => makeSelectChatInfoById(),
    []
  );
  const selectChat: ChatWithShortInfo | undefined = useSelector((state: ApplicationStore) =>
    selectChatInfoById(state, chatId)
  );

  const [chatInfo, setChatInfo]: [ChatInfoProps, React.Dispatch<React.SetStateAction<any>>] = useState<ChatInfoProps>({
    name: selectChat?.name ? selectChat?.name : selectChat?.opponentPhone ?? "",
    opponentLogin: selectChat?.opponentLogin ?? "",
    opponentPhone: selectChat?.opponentPhone ?? "",
    activePhone: selectChat?.activePhone ?? ""
  });

  useEffect(() => {
    setIsClickChangeName(false);
    setChatInfo({
      name: selectChat?.name ? selectChat?.name : selectChat?.opponentPhone ?? "",
      opponentLogin: selectChat?.opponentLogin ?? "",
      opponentPhone: selectChat?.opponentPhone ?? "",
      activePhone: selectChat?.activePhone ?? ""
    });
  }, [selectChat]);

  useEffect(() => {
    if (isClickChangeName == true) {
      refInputChangeName.current?.focus();
    }
  }, [isClickChangeName]);

  const handleClickOnName: () => void = () => {
    setIsClickChangeName(!isClickChangeName);
  };

  const handleChangeName: (target: { value: string }) => void = (target: { value: string }): void => {
    setChatInfo({ ...chatInfo, name: target.value });
  };

  const handleSaveChangeName: () => void = (): void => {
    if (chatId && selectChat) {
      dispatch(chatActions.updateChat({ chatId: chatId, name: chatInfo.name }));
    }

    setIsClickChangeName(!isClickChangeName);
  };

  const handleKeyDownOnInput: (event: React.KeyboardEvent<HTMLInputElement>) => void = (
    event: React.KeyboardEvent<HTMLInputElement>
  ): void => {
    if (event.key === "Enter") {
      handleSaveChangeName();
    }

    if (event.key === "Escape") {
      setIsClickChangeName(!isClickChangeName);
      setChatInfo({ ...chatInfo, name: selectChat?.name ?? "" });
    }
  };

  return (
    <div className={styles.chatInfo}>
      <div className={styles.nameWrapper}>
        {isClickChangeName == false && (
          <div className={styles.name} onClick={(): void => handleClickOnName()}>
            {chatInfo.name}
          </div>
        )}
        {isClickChangeName == true && (
          <div className={styles.form}>
            <input
              type="text"
              ref={refInputChangeName}
              value={chatInfo.name}
              onChange={(e): void => handleChangeName(e.target)}
              onKeyDown={(event): void => {
                handleKeyDownOnInput(event);
              }}
            ></input>
            <button onClick={handleSaveChangeName}>Save</button>
          </div>
        )}
      </div>
      {isClickChangeName == false && (
        <div className={styles.phone}>
          {chatInfo.opponentPhone !== "" && <div>Client: {chatInfo.opponentPhone ?? ""}</div>}
          {chatInfo.activePhone !== "" && <div>Twilio: {chatInfo.activePhone}</div>}
          {chatInfo.opponentLogin !== "" && <div>User: {chatInfo.opponentLogin}</div>}
        </div>
      )}
    </div>
  );
};

export default ChatInfoComponent;
